// Misma copia del Excel de Agus. Si el API aún no responde, la pantalla enseña esto.
export const DESIGN_CALENDAR_SEED_YEAR = 2026;

export const designCalendarSeedNotas = [
  {
    Id: 1,
    Fecha: "2026-01-01",
    Texto: "MEETING SCALPERS SUMMER",
    Simbolo: "meeting",
    Origen: "crm",
  },
  {
    Id: 2,
    Fecha: "2026-01-14",
    Texto: "METING PEDRO DEL HIERRO",
    Simbolo: "meeting",
    Origen: "crm",
  },
  {
    Id: 3,
    Fecha: "2026-01-18",
    Texto: "VIAJE CHINA AGUS ( 18 al 30 )",
    Simbolo: "viaje",
    Origen: "crm",
  },
  {
    Id: 4,
    Fecha: "2026-01-21",
    Texto: "MEETING SHANGHAI ZARA ATEMPORARY",
    Simbolo: "meeting",
    Origen: "crm",
  },
  {
    Id: 5,
    Fecha: "2026-01-25",
    Texto: "SHOPPING SALES CHINA",
    Simbolo: "viaje",
    Origen: "crm",
  },
  {
    Id: 6,
    Fecha: "2026-01-26",
    Texto: "DEVELOPMENTS AW25",
    Simbolo: "nota",
    Origen: "crm",
  },
  {
    Id: 7,
    Fecha: "2026-01-29",
    Texto: "BHOEM MEETING CHINA HS",
    Simbolo: "meeting",
    Origen: "crm",
  },
  {
    Id: 8,
    Fecha: "2026-01-30",
    Texto: "BHOEM MEETING CHINA NML",
    Simbolo: "meeting",
    Origen: "crm",
  },
  {
    Id: 9,
    Fecha: "2026-01-31",
    Texto: "ZARA MEETING IN SPAIN WITH LARRY",
    Simbolo: "meeting",
    Origen: "crm",
  },
  {
    Id: 10,
    Fecha: "2026-02-01",
    Texto: "EASYWEAR MAN - SUMMER",
    Simbolo: "nota",
    Origen: "crm",
  },
  {
    Id: 11,
    Fecha: "2026-02-03",
    Texto: "FERIA / TEXWORLD PARIS SS26",
    Simbolo: "feria",
    Origen: "crm",
  },
  {
    Id: 12,
    Fecha: "2026-02-04",
    Texto: "FERIA / TEXWORLD - PREMIERE VISION PARIS",
    Simbolo: "feria",
    Origen: "crm",
  },
  {
    Id: 13,
    Fecha: "2026-02-05",
    Texto: "FERIA / TEXWORLD - PREMIERE VISION PARIS",
    Simbolo: "feria",
    Origen: "crm",
  },
  {
    Id: 14,
    Fecha: "2026-02-05",
    Texto: "MEETING JULIO SUMMER / SITGES",
    Simbolo: "meeting",
    Origen: "crm",
  },
  {
    Id: 15,
    Fecha: "2026-02-11",
    Texto: "MEETIN SILBON",
    Simbolo: "meeting",
    Origen: "crm",
  },
  {
    Id: 16,
    Fecha: "2026-02-12",
    Texto: "PARFOIS",
    Simbolo: "nota",
    Origen: "crm",
  },
  {
    Id: 17,
    Fecha: "2026-02-13",
    Texto: "MEETING INDI & COLD SS26",
    Simbolo: "meeting",
    Origen: "crm",
  },
  {
    Id: 18,
    Fecha: "2026-02-16",
    Texto: "MEETING LOLA CASADEMUNT FA26",
    Simbolo: "meeting",
    Origen: "crm",
  },
  {
    Id: 19,
    Fecha: "2026-02-17",
    Texto: "AÑO NUEVO CHINO",
    Simbolo: "festival",
    Origen: "crm",
  },
  {
    Id: 20,
    Fecha: "2026-02-19",
    Texto: "MEETIONG SITGES ZARA GLOBAL URBAN",
    Simbolo: "meeting",
    Origen: "crm",
  },
  {
    Id: 21,
    Fecha: "2026-02-20",
    Texto: "WINTER DEVELPMENTS -TRANSITION -PU -PUFFA-ETC",
    Simbolo: "nota",
    Origen: "crm",
  },
  {
    Id: 22,
    Fecha: "2026-02-23",
    Texto: "MEETIONG SITGES ZARA GLOBAL TREND (WINTER)",
    Simbolo: "meeting",
    Origen: "crm",
  },
  {
    Id: 23,
    Fecha: "2026-02-24",
    Texto: "MEETING TH /M -W PREFALL",
    Simbolo: "meeting",
    Origen: "crm",
  },
  {
    Id: 24,
    Fecha: "2026-02-25",
    Texto: "MEETING KARL MAIN COLLECTION",
    Simbolo: "meeting",
    Origen: "crm",
  },
  {
    Id: 25,
    Fecha: "2026-02-25",
    Texto: "MEETING KARL OUTLET - PRESPRING",
    Simbolo: "meeting",
    Origen: "crm",
  },
  {
    Id: 26,
    Fecha: "2026-02-26",
    Texto: "MEETING ZARA - ARTEIXO",
    Simbolo: "meeting",
    Origen: "crm",
  },
  {
    Id: 27,
    Fecha: "2026-03-04",
    Texto: "MEETIN SILBON WOMAN -SITGES",
    Simbolo: "meeting",
    Origen: "crm",
  },
  {
    Id: 28,
    Fecha: "2026-03-09",
    Texto: "ZARA CONOSUR MEETING BERRY BOOM",
    Simbolo: "meeting",
    Origen: "crm",
  },
  {
    Id: 29,
    Fecha: "2026-03-10",
    Texto: "VIAJE CHINA - CANCELLED",
    Simbolo: "viaje",
    Origen: "crm",
  },
  {
    Id: 30,
    Fecha: "2026-03-11",
    Texto: "FAIR / SHANGHAI INTERTEXTIL SS26",
    Simbolo: "feria",
    Origen: "crm",
  },
  {
    Id: 31,
    Fecha: "2026-03-12",
    Texto: "FAIR / SHANGHAI INTERTEXTIL",
    Simbolo: "feria",
    Origen: "crm",
  },
  {
    Id: 32,
    Fecha: "2026-03-13",
    Texto: "FAIR / SHANGHAI INTERTEXTIL",
    Simbolo: "feria",
    Origen: "crm",
  },
  {
    Id: 33,
    Fecha: "2026-03-16",
    Texto: "BIMBA Y LOLA FA26 &SS27",
    Simbolo: "nota",
    Origen: "crm",
  },
  {
    Id: 34,
    Fecha: "2026-03-17",
    Texto: "PARFOIS",
    Simbolo: "nota",
    Origen: "crm",
  },
  {
    Id: 35,
    Fecha: "2026-03-20",
    Texto: "MEETING LOLA CASADEMUNT - PILAR",
    Simbolo: "meeting",
    Origen: "crm",
  },
  {
    Id: 36,
    Fecha: "2026-03-24",
    Texto: "SCALPERS",
    Simbolo: "nota",
    Origen: "crm",
  },
  {
    Id: 37,
    Fecha: "2026-03-27",
    Texto: "MEETING ZARA GLOBAL TREND SHANGHAI",
    Simbolo: "meeting",
    Origen: "crm",
  },
  {
    Id: 38,
    Fecha: "2026-03-28",
    Texto: "WINTER DEVELOPMENTS FROM FEBRUARY",
    Simbolo: "nota",
    Origen: "crm",
  },
  {
    Id: 39,
    Fecha: "2026-04-04",
    Texto: "FESTIVAL QINGMIN",
    Simbolo: "festival",
    Origen: "crm",
  },
  {
    Id: 40,
    Fecha: "2026-04-06",
    Texto: "VIAJE CHINA AGUS ( 6 al 14 )",
    Simbolo: "viaje",
    Origen: "crm",
  },
  {
    Id: 41,
    Fecha: "2026-04-08",
    Texto: "ZARA ZERO MEETING AOTAI",
    Simbolo: "meeting",
    Origen: "crm",
  },
  {
    Id: 42,
    Fecha: "2026-04-16",
    Texto: "KARL EN SITGES",
    Simbolo: "nota",
    Origen: "crm",
  },
  {
    Id: 43,
    Fecha: "2026-04-22",
    Texto: "MEETING ZARA ALL TEAMS - ARTEIXO / AW26",
    Simbolo: "meeting",
    Origen: "crm",
  },
  {
    Id: 44,
    Fecha: "2026-05-01",
    Texto: "DIA TRABAJO",
    Simbolo: "nota",
    Origen: "crm",
  },
  {
    Id: 45,
    Fecha: "2026-05-05",
    Texto: "MEETING TH MAN / WOMAN /RUNWAY FALL",
    Simbolo: "meeting",
    Origen: "crm",
  },
  {
    Id: 46,
    Fecha: "2026-05-06",
    Texto: "KARL OUTLET SS MAN / KARL WOMAN",
    Simbolo: "nota",
    Origen: "crm",
  },
  {
    Id: 47,
    Fecha: "2026-05-22",
    Texto: "NML CHINA",
    Simbolo: "nota",
    Origen: "crm",
  },
  {
    Id: 48,
    Fecha: "2026-05-25",
    Texto: "NML BHOEME MEETING CHINA - HS",
    Simbolo: "meeting",
    Origen: "crm",
  },
  {
    Id: 49,
    Fecha: "2026-05-27",
    Texto: "ZARA GLOBAL URBAN - MEETING CHINA (FIN INVIERNO)",
    Simbolo: "meeting",
    Origen: "crm",
  },
  {
    Id: 50,
    Fecha: "2026-06-02",
    Texto: "FERIA- BARCELONA TEXTIL EXPO WINTER 26-27",
    Simbolo: "feria",
    Origen: "crm",
  },
  {
    Id: 51,
    Fecha: "2026-06-04",
    Texto: "MEETING SILBON SUMMER",
    Simbolo: "meeting",
    Origen: "crm",
  },
  {
    Id: 52,
    Fecha: "2026-06-10",
    Texto: "MEETING ZARA ALL TEAMS - ARTEIXO / AW26",
    Simbolo: "meeting",
    Origen: "crm",
  },
  {
    Id: 53,
    Fecha: "2026-06-15",
    Texto: "NLM JULIO -VISIT SITGES -MARIA",
    Simbolo: "nota",
    Origen: "crm",
  },
  {
    Id: 54,
    Fecha: "2026-06-19",
    Texto: "DRAGON BOAT FESTIVAL",
    Simbolo: "festival",
    Origen: "crm",
  },
  {
    Id: 55,
    Fecha: "2026-06-23",
    Texto: "MEETING KARL OUTLET PREFALL",
    Simbolo: "meeting",
    Origen: "crm",
  },
  {
    Id: 56,
    Fecha: "2026-06-25",
    Texto: "VIAJE SHOPPING - LONDON 25-26",
    Simbolo: "viaje",
    Origen: "crm",
  },
  {
    Id: 57,
    Fecha: "2026-07-04",
    Texto: "SHOPPING BARCELONA",
    Simbolo: "viaje",
    Origen: "crm",
  },
  {
    Id: 58,
    Fecha: "2026-07-11",
    Texto: "MEETING TH SUMMER PRESPRING",
    Simbolo: "meeting",
    Origen: "crm",
  },
  {
    Id: 59,
    Fecha: "2026-07-15",
    Texto: "MEETING INDI &COLD WINTER",
    Simbolo: "meeting",
    Origen: "crm",
  },
  {
    Id: 60,
    Fecha: "2026-07-16",
    Texto: "MEETING ZARA ALL TEAMS",
    Simbolo: "meeting",
    Origen: "crm",
  },
  {
    Id: 61,
    Fecha: "2026-07-17",
    Texto: "MEETING ZARA ALL TEAMS",
    Simbolo: "meeting",
    Origen: "crm",
  },
  {
    Id: 62,
    Fecha: "2026-07-21",
    Texto: "ZARA GLOBAL URBAN - MEETING SITGES",
    Simbolo: "meeting",
    Origen: "crm",
  },
  {
    Id: 63,
    Fecha: "2026-07-23",
    Texto: "MEETIN SCALPERSWINTER (MAN / WOMAN)",
    Simbolo: "meeting",
    Origen: "crm",
  },
  {
    Id: 64,
    Fecha: "2026-07-25",
    Texto: "MEETING ZGLOBAL TREND AW25 - SHANGHAI",
    Simbolo: "meeting",
    Origen: "crm",
  },
  {
    Id: 65,
    Fecha: "2026-07-30",
    Texto: "INDI & COLD en la oficina",
    Simbolo: "nota",
    Origen: "crm",
  },
  {
    Id: 66,
    Fecha: "2026-07-30",
    Texto: "MEETING ZARA ALL TEAMS",
    Simbolo: "meeting",
    Origen: "crm",
  },
  {
    Id: 67,
    Fecha: "2026-07-31",
    Texto: "LOLA CSDMNT / SUMMER desarrollos en Sitges",
    Simbolo: "nota",
    Origen: "crm",
  },
  {
    Id: 68,
    Fecha: "2026-08-05",
    Texto: "NEXT BRAND in SITGES",
    Simbolo: "nota",
    Origen: "crm",
  },
  {
    Id: 69,
    Fecha: "2026-08-23",
    Texto: "VIAJE CHINA",
    Simbolo: "viaje",
    Origen: "crm",
  },
  {
    Id: 70,
    Fecha: "2026-08-25",
    Texto: "FAIR / SHANGHAI INTERTEXTIL SS26",
    Simbolo: "feria",
    Origen: "crm",
  },
  {
    Id: 71,
    Fecha: "2026-08-26",
    Texto: "FAIR / SHANGHAI INTERTEXTIL SS26",
    Simbolo: "feria",
    Origen: "crm",
  },
  {
    Id: 72,
    Fecha: "2026-08-27",
    Texto: "FAIR / SHANGHAI INTERTEXTIL SS26",
    Simbolo: "feria",
    Origen: "crm",
  },
  {
    Id: 73,
    Fecha: "2026-08-28",
    Texto: "SHOPPING SALES CHINA",
    Simbolo: "viaje",
    Origen: "crm",
  },
  {
    Id: 74,
    Fecha: "2026-08-29",
    Texto: "KARL OUTLET /KARL MAIN FALL",
    Simbolo: "nota",
    Origen: "crm",
  },
  {
    Id: 75,
    Fecha: "2026-08-30",
    Texto: "MEETING JULIO WINTER",
    Simbolo: "meeting",
    Origen: "crm",
  },
  {
    Id: 76,
    Fecha: "2026-08-31",
    Texto: "FERIA / TEXWORLD PARIS SS26 / PV PARIS",
    Simbolo: "feria",
    Origen: "crm",
  },
  {
    Id: 77,
    Fecha: "2026-09-01",
    Texto: "KARL OUTLET WOMAN / KARL MAIN",
    Simbolo: "nota",
    Origen: "crm",
  },
  {
    Id: 78,
    Fecha: "2026-09-10",
    Texto: "FAIR / TURKEY TEXHIBITION 10/11/12",
    Simbolo: "feria",
    Origen: "crm",
  },
  {
    Id: 79,
    Fecha: "2026-09-15",
    Texto: "MEETING ZGLOBAL URBAN SS26 - SHANGHAI",
    Simbolo: "meeting",
    Origen: "crm",
  },
  {
    Id: 80,
    Fecha: "2026-09-19",
    Texto: "MEETING ZARA ALL TEAMS /17-18-19 SEPT",
    Simbolo: "meeting",
    Origen: "crm",
  },
  {
    Id: 81,
    Fecha: "2026-09-25",
    Texto: "JULIO MEETING /VISITA SITGES WINTER",
    Simbolo: "meeting",
    Origen: "crm",
  },
  {
    Id: 82,
    Fecha: "2026-09-26",
    Texto: "AUTUMN FESTIVAL",
    Simbolo: "festival",
    Origen: "crm",
  },
  {
    Id: 83,
    Fecha: "2026-10-01",
    Texto: "BIMBA Y LOLA -WINTER SITGES",
    Simbolo: "nota",
    Origen: "crm",
  },
  {
    Id: 84,
    Fecha: "2026-10-20",
    Texto: "VIAJE CHINA",
    Simbolo: "viaje",
    Origen: "crm",
  },
  {
    Id: 85,
    Fecha: "2026-10-24",
    Texto: "MEETING ZGLOBAL TREND - SHANGHAI",
    Simbolo: "meeting",
    Origen: "crm",
  },
  {
    Id: 86,
    Fecha: "2026-10-26",
    Texto: "DEVELOPMENTS SUMMER",
    Simbolo: "nota",
    Origen: "crm",
  },
  {
    Id: 87,
    Fecha: "2026-10-27",
    Texto: "SHOPPING SUMMER",
    Simbolo: "viaje",
    Origen: "crm",
  },
  {
    Id: 88,
    Fecha: "2026-11-01",
    Texto: "MEETING TH MAN SS",
    Simbolo: "meeting",
    Origen: "crm",
  },
  {
    Id: 89,
    Fecha: "2026-11-03",
    Texto: "MEETING PEPE JEANS SUMMER",
    Simbolo: "meeting",
    Origen: "crm",
  },
  {
    Id: 90,
    Fecha: "2026-11-05",
    Texto: "VIAJE CHINA",
    Simbolo: "viaje",
    Origen: "crm",
  },
  {
    Id: 91,
    Fecha: "2026-11-13",
    Texto: "MEETING ZGLOBAL TREND - SHANGHAI",
    Simbolo: "meeting",
    Origen: "crm",
  },
  {
    Id: 92,
    Fecha: "2026-11-18",
    Texto: "MEETING SCALPERS MAN SUMMER",
    Simbolo: "meeting",
    Origen: "crm",
  },
  {
    Id: 93,
    Fecha: "2026-12-01",
    Texto: "MEETING SCALPERS MAN SUMMER",
    Simbolo: "meeting",
    Origen: "crm",
  },
  {
    Id: 94,
    Fecha: "2026-12-11",
    Texto: "MEETING ZARA ALL TEAMS",
    Simbolo: "meeting",
    Origen: "crm",
  },
  {
    Id: 95,
    Fecha: "2026-12-12",
    Texto: "MEETING ZARA ALL TEAMS",
    Simbolo: "meeting",
    Origen: "crm",
  },
  {
    Id: 96,
    Fecha: "2026-12-15",
    Texto: "MEETING LOLA CSDMNT WINTER",
    Simbolo: "meeting",
    Origen: "crm",
  },
  {
    Id: 97,
    Fecha: "2026-12-18",
    Texto: "MEETING SCALPERS M/W SS",
    Simbolo: "meeting",
    Origen: "crm",
  },
];

export const designCalendarSeedAcciones = [
  {
    Id: 1,
    Anio: 2026,
    Mes: 1,
    Texto: "DISEÑO TH/ MAN -WOMAN PASARELA MOCK UPS",
    FechaAviso: "2026-01-01",
    Hecho: false,
    Origen: "crm",
  },
  {
    Id: 2,
    Anio: 2026,
    Mes: 3,
    Texto: "LANZAR KARL OUTLET PREFALL 1ST DROP (woman) / MAN se nutre de ZM",
    FechaAviso: "2026-03-01",
    Hecho: false,
    Origen: "crm",
  },
  {
    Id: 3,
    Anio: 2026,
    Mes: 3,
    Texto: "LANZAR LOLA SUMMER",
    FechaAviso: "2026-03-01",
    Hecho: false,
    Origen: "crm",
  },
  {
    Id: 4,
    Anio: 2026,
    Mes: 4,
    Texto: "SCALPERS WOMAN -LANZAR A AOTAI (ver otro fabric product)",
    FechaAviso: "2026-04-01",
    Hecho: false,
    Origen: "crm",
  },
  {
    Id: 5,
    Anio: 2026,
    Mes: 4,
    Texto: "INICIO JULIO WINTER",
    FechaAviso: "2026-04-01",
    Hecho: false,
    Origen: "crm",
  },
  {
    Id: 6,
    Anio: 2026,
    Mes: 4,
    Texto: "INICIO NIDI & COLD WINTER",
    FechaAviso: "2026-04-01",
    Hecho: false,
    Origen: "crm",
  },
  {
    Id: 7,
    Anio: 2026,
    Mes: 5,
    Texto: "INICIO TH SUMMER MAN-WOMAN -PRESPRING Y SPRING",
    FechaAviso: "2026-05-01",
    Hecho: false,
    Origen: "crm",
  },
  {
    Id: 8,
    Anio: 2026,
    Mes: 5,
    Texto: "LANZAR KARL OUTLET FALL 2ND DROP",
    FechaAviso: "2026-05-01",
    Hecho: false,
    Origen: "crm",
  },
  {
    Id: 9,
    Anio: 2026,
    Mes: 6,
    Texto: "INICIO DISEÑO ZARA WOMAN SS26",
    FechaAviso: "2026-06-01",
    Hecho: false,
    Origen: "crm",
  },
  {
    Id: 10,
    Anio: 2026,
    Mes: 6,
    Texto: "INICIO DISEÑO ZARA MAN SS26",
    FechaAviso: "2026-06-01",
    Hecho: false,
    Origen: "crm",
  },
  {
    Id: 11,
    Anio: 2026,
    Mes: 7,
    Texto: "INICIO BIMBA &LOLA FUR (AOTAI) x3 DEVELOP + FUR RESEARCH",
    FechaAviso: "2026-07-01",
    Hecho: false,
    Origen: "crm",
  },
  {
    Id: 12,
    Anio: 2026,
    Mes: 7,
    Texto: "INICIO PEPE JEANS SUMMER",
    FechaAviso: "2026-07-01",
    Hecho: false,
    Origen: "crm",
  },
  {
    Id: 13,
    Anio: 2026,
    Mes: 7,
    Texto: "REBAJAS BARCELONA",
    FechaAviso: "2026-07-01",
    Hecho: false,
    Origen: "crm",
  },
  {
    Id: 14,
    Anio: 2026,
    Mes: 7,
    Texto: "INICIO KIDS SUMMER",
    FechaAviso: "2026-07-01",
    Hecho: false,
    Origen: "crm",
  },
  {
    Id: 15,
    Anio: 2026,
    Mes: 9,
    Texto: "INICIO LOLA WINTER",
    FechaAviso: "2026-09-01",
    Hecho: false,
    Origen: "crm",
  },
  {
    Id: 16,
    Anio: 2026,
    Mes: 9,
    Texto: "INICIO SCALPERS MAN SUMMER (x3 DEV)",
    FechaAviso: "2026-09-01",
    Hecho: false,
    Origen: "crm",
  },
  {
    Id: 17,
    Anio: 2026,
    Mes: 9,
    Texto: "INICIO SCALPERS WOMAN SUMMER (x3 DEV) MIXED GARMENTS",
    FechaAviso: "2026-09-01",
    Hecho: false,
    Origen: "crm",
  },
  {
    Id: 18,
    Anio: 2026,
    Mes: 10,
    Texto: "INICIO DISEÑO /PEPE JEANS PREFALL COLLECTION",
    FechaAviso: "2026-10-01",
    Hecho: false,
    Origen: "crm",
  },
  {
    Id: 19,
    Anio: 2026,
    Mes: 10,
    Texto: "INICIO JULIO DISEÑO SUMMER",
    FechaAviso: "2026-10-01",
    Hecho: false,
    Origen: "crm",
  },
  {
    Id: 20,
    Anio: 2026,
    Mes: 10,
    Texto: "INICIO TH PREFALL/ FALL",
    FechaAviso: "2026-10-01",
    Hecho: false,
    Origen: "crm",
  },
  {
    Id: 21,
    Anio: 2026,
    Mes: 11,
    Texto: "INICIO ZARA WOMAN FUR COLLECTION",
    FechaAviso: "2026-11-01",
    Hecho: false,
    Origen: "crm",
  },
  {
    Id: 22,
    Anio: 2026,
    Mes: 11,
    Texto: "INICIO KARL OUTLET WOMAN 1st DROP PRESPRING",
    FechaAviso: "2026-11-01",
    Hecho: false,
    Origen: "crm",
  },
  {
    Id: 23,
    Anio: 2026,
    Mes: 11,
    Texto: "BIMBA & LOLA SUMMER (mover patrones de ZW - lanzar x3 DEV)",
    FechaAviso: "2026-11-01",
    Hecho: false,
    Origen: "crm",
  },
  {
    Id: 24,
    Anio: 2026,
    Mes: 12,
    Texto: "LANZAR KARL OUTLET SUMMER 2nd DROP (woman)",
    FechaAviso: "2026-12-01",
    Hecho: false,
    Origen: "crm",
  },
  {
    Id: 25,
    Anio: 2026,
    Mes: 12,
    Texto: "SEPHIA - SIEMPRE LANZAR RESEARCH TEJIDOS",
    FechaAviso: "2026-12-01",
    Hecho: false,
    Origen: "crm",
  },
  {
    Id: 26,
    Anio: 2026,
    Mes: 12,
    Texto: "ANTES DE DESARROLLOS",
    FechaAviso: "2026-12-01",
    Hecho: false,
    Origen: "crm",
  },
  {
    Id: 27,
    Anio: 2026,
    Mes: 12,
    Texto: "BAJAR WEBS PRODUCTS /cada uno -practicas",
    FechaAviso: "2026-12-01",
    Hecho: false,
    Origen: "crm",
  },
  {
    Id: 28,
    Anio: 2026,
    Mes: 2,
    Texto: "SEPHIA TEAM / BUSY CANT MAKE DEVELOPMENTS",
    FechaAviso: "2026-02-01",
    Hecho: false,
    Origen: "crm",
  },
];
